import '../httpservices/core/ajax.httpservice.core';

class MessageHttpService {

    DeletePsmAttachement(attachmentGroupId, fileName, isTempUpload) {
        return $.post('api/Message/RemoveAttachmentFromGroup', { attachmentGroupId, fileName, isTempUpload });
    }

    ComposeMessagePageInit() {
        return $.get('api/Message/ComposeMessagePageInit');
    }

    ComposeMessageSendMessage(templateId, composeModel) {
        return $.post('api/Message/SendAMessage', composeModel, { messageType: templateId });
    }

    ComposeMessageSendEmailMessage(templateId, composeModel) {
        return $.post('api/EmailMessage/SendEmailMessage', composeModel, { messageType: templateId });
    }

    MessageListingInit() {
        return $.get('api/Message/ListingPageIndexInit');
    }

    MessageSelect() {
        return $.get('api/Message/MessageSelect');
    }

    MessageDetailSelect(messageId) {
        return $.get('api/Message/MessageDetailSelect?messageId=' + messageId);
    }

    DeleteMessage(messageId) {
        return $.delete('api/Message/DeleteAMessage?messageId=' + messageId);
    }

    RestoreMessage(messageId) {
        return $.post('api/Message/RestoreDeletedMessage?messageId=' + messageId);
    }

    GetIntracavernosalTherapyInitData() {
        return $.get('api/Message/GetIntracavernosalTherapyPageInit');
    }

    GetContent() {
        return $.get('api/Message/GetContent');
    }

    ClinicalGeneticsComposeTemplateInit() {
        return $.get('api/Message/ClinicalGeneticsComposeTemplateInit');
    }

}

export const MessageHttpSvc = new MessageHttpService();